// src/pages/Dashboard/constants.js
import { getStoredData } from "../../api/fetchData.jsx";

export const COLORS = ["#2563eb", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"];

const stored = getStoredData();

const baseApi =
  Array.isArray(stored) && stored.length > 0 && stored[0]?.Api
    ? stored[0].Api
    : "https://jkumarapi.axiomos.in";

export const API_BASE = baseApi;
export const SAFETY_REPORT_API = `${baseApi}/safetyreport`;
